<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end">
		<app-document-viewer (close)="toggleSlide(); documentLoadUnsubscriber$.next()" *ngIf="viewDocument"
			[documentDetails]="selectedDocumentDetails"></app-document-viewer>

		<app-loader *ngIf="viewEmail"></app-loader>
	</mat-sidenav>


	<mat-sidenav-content [class.opened]="isOpened">
		<div class="main-container lg-view">
			<h3>Deficiency Details</h3>

			<form class="main-form" [formGroup]="deficiencyFormGroup" *ngIf="isEditMode" @fadeIn>

				<mat-form-field class="container">
					<mat-label>Site</mat-label>
					<mat-select formControlName="siteObj">
						<mat-option *ngFor="let item of sites" [value]="item">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field class="container">
					<mat-label>Class</mat-label>
					<mat-select formControlName="classObj">
						<mat-option *ngFor="let item of deficiencyClasses" [value]="item">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field class="container">
					<mat-label>Type</mat-label>
					<mat-select formControlName="typeObj">
						<mat-option *ngFor="let item of deficiencyTypes" [value]="item">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field class="container">
					<mat-label>Subtype</mat-label>
					<mat-select formControlName="subtypeObj">
						<mat-option *ngFor="let item of deficiencySubtypes" [value]="item">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<div class="container">
					<mat-checkbox formControlName="isEmergency">Emergency</mat-checkbox>
				</div>

				<mat-form-field class="container column">
					<mat-label>Note</mat-label>
					<textarea matInput formControlName="note"></textarea>
				</mat-form-field>

				<!-- <div class="container assignee-selector-container">
					<mat-checkbox formControlName="isCompletionRequired">Requires Completion</mat-checkbox>

					<mat-form-field class="container assignee-selector">
						<mat-label>Assigned To</mat-label>
						<mat-select formControlName="assignedUserObj">
							<mat-option *ngFor="let item of possibleAssignees" [value]="item">
								{{item.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div> -->

				<div class="container photos-container" @fadeIn @fadeOut *ngIf="isEditMode">
					<button mat-icon-button type="button" (click)="fileInput.click()">
						<mat-icon svgIcon="site_note_deficiency_add_photo"></mat-icon>
					</button>
				</div>
			</form>

			<div class="item-container" *ngIf="!isEditMode" @fadeIn>
				<div class="item-details">
					<span class="deficiency-number" *ngIf="deficiency.deficiencyNumber">
						#{{ deficiency.deficiencyNumber }}
					</span>

					<span class="address" *ngIf="deficiency.siteAddress">
						{{ deficiency.siteAddress }}
					</span>

					<span class="comment" *ngIf="deficiency.comment">
						{{ deficiency.comment }}
					</span>

					<span class="deficiency-class" *ngIf="deficiency.className">
						<span class="label">{{ deficiency.classAlias || 'Class' }}:</span>
						{{ deficiency.className }}
					</span>
					<span class="deficiency-type" *ngIf="deficiency.typeName">
						<span class="label">{{ deficiency.typeAlias || 'Type' }}:</span>
						{{ deficiency.typeName }}
					</span>
					<span class="deficiency-subtype" *ngIf="deficiency.subTypeName">
						<span class="label">{{ deficiency.subTypeAlias || 'Subtype' }}:</span>
						{{ deficiency.subTypeName }}
					</span>
					<span class="deficiency-standard-class" *ngIf="deficiency.standardClassName">
						<span class="label">Standard Class:</span>
						{{ deficiency.standardClassName }}
					</span>
					<span class="deficiency-standard-type" *ngIf="deficiency.standardTypeName">
						<span class="label">Standard Type:</span>
						{{ deficiency.standardTypeName }}
					</span>
					
					<span class="deficiency-floor" *ngIf="deficiency.isFloorEnabled">
						<span class="label">Floor:</span> 
						{{ deficiency.floor || 'n/a' }}
					</span>
					<span class="deficiency-room" *ngIf="deficiency.isRoomEnabled">
						<span class="label">Room:</span> 
						{{ deficiency.room || 'n/a' }}
					</span>
					<span class="deficiency-location" *ngIf="deficiency.isLocationEnabled">
						<span class="label">Location:</span> 
						{{ deficiency.location || 'n/a' }}
					</span>

					<span class="emergency">
						<span class="label">{{ deficiency.emergencyAlias ? deficiency.emergencyAlias : 'Emergency' }}:</span>
						{{ deficiency.isEmergency ? 'YES' : 'NO' }}
					</span>

					<span class="generic-option" *ngIf="deficiency.isGenericOptionEnabled">
						<span class="label">{{ deficiency.genericOptionAlias ? deficiency.genericOptionAlias : 'Generic Option' }}:</span>
						{{ deficiency.genericOptionValue ? 'YES' : 'NO' }}
					</span>

					<span class="created-by-on">
						Submitted by {{ deficiency.requestedBy }}
						on {{ moment(deficiency.requestedOn).format('MM/DD/YYYY hh:mm A') }}
					</span>

					<span class="photo-count" *ngIf="!!deficiency.photosCount">({{ deficiency.photosCount }} {{
						deficiency.photosCount > 1 ? 'photos' : 'photo' }})</span>

					<div class="documents-container" *ngIf="!isDocumentsLoading && documents?.length">
						<div class="document" *ngFor="let document of documents" (click)="showDocument(document)">
							<div class="thumbnail-container">
								<img src="../../../../assets/icons/camera-icon-black.svg" />
							</div>
							<div class="document-name">
								<span class="name" *ngIf="document.name">{{ document.name }}</span>
								<span class="description" *ngIf="document.description">{{ document.description }}</span>
							</div>
						</div>
					</div>

					<app-loader [hasTransparency]="true" [isInline]="true" [loaderMessage]="'Loading Photos'"
						*ngIf="isDocumentsLoading"></app-loader>

				</div>
			</div>

			<input type="file" hidden #fileInput>
		</div>

		<div class="actions-container md-view" *ngIf="!isLoading">
			<ng-container>
			<!--<action-button @fadeIn *ngIf="!isEditMode" [icon]="ButtonIcons.Edit" [name]="'Edit'"
					[clickAction]="startEditMode.bind(self)"></action-button>-->	
				<action-button @fadeIn *ngIf="!isEditMode" [icon]="ButtonIcons.Link" [name]="'Copy Link'" [cdkCopyToClipboard]="location.href" [clickAction]="triggerCopyToast.bind(self)"></action-button>

					
				<action-button @fadeIn *ngIf="isEditMode" [disabled]="deficiencyFormGroup.invalid"
					[icon]="ButtonIcons.Save" [name]="'Save'" [clickAction]="updateDeficiency.bind(self)">
				</action-button>
				<action-button @fadeIn *ngIf="isEditMode" [icon]="ButtonIcons.Cancel" [name]="'Cancel'"
					[clickAction]="stopEditMode.bind(self)"></action-button>
			</ng-container>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>